import { render, staticRenderFns } from "./AppLauncher.vue?vue&type=template&id=0fa72c2c&scoped=true"
import script from "./AppLauncher.vue?vue&type=script&lang=ts"
export * from "./AppLauncher.vue?vue&type=script&lang=ts"
import style0 from "./AppLauncher.vue?vue&type=style&index=0&id=0fa72c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_css-loader@7.1.4_webpack@5.105.3__ejs@3.1.1_a26f30fb19caf7f85e132ae92399ad32/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa72c2c",
  null
  
)

export default component.exports